module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n<router-outlet></router-outlet>\n\n"


//////////////////
// WEBPACK FOOTER
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main